module.exports = "<nv-react-component component=\"InstitutionDashboard\"></nv-react-component>";